/* istanbul ignore file */
import React from 'react';
import { SingleBreadcrumbItem } from 'framework/ui/BreadCrumbs';
import { useShowContext } from 'framework/show';
import LedgerBreadcrumbs from 'domain/finance/ledger/shared/LedgerBreadcrumbs';
import { Box } from '@mui/material';
import { updateCurrencyName } from 'framework/utils';
import { useLedgerUrl } from 'domain/shared/ledger';

const SingleLedgerBreadcrumbs = ({ children }: { children?: React.ReactNode }) => {
  const { data } = useShowContext();
  const { getSingleEntityUrl } = useLedgerUrl();
  const id = data.getValueBySource('id');
  const displayedName = id.split('/').map((item: string, i: number) => (
    <React.Fragment key={item}>
      {i ? (
        <Box
          component="span"
          sx={{
            marginLeft: '8px',
            marginRight: '8px',
            display: 'inline-block',
          }}
        >
          /
        </Box>
      ) : null}
      {updateCurrencyName(item)}
    </React.Fragment>
  ));

  return (
    <LedgerBreadcrumbs>
      <SingleBreadcrumbItem entity={displayedName} link={getSingleEntityUrl(id)} />
      {children}
    </LedgerBreadcrumbs>
  );
};

export default SingleLedgerBreadcrumbs;
